export enum CadastroDocumentoTipo {
    CONTRATO = 'CONTRATO',
    PROCURACAO = 'PROCURACAO',
    DECLARACAO_VIZINHO = 'DECLARACAO_VIZINHO',
    DECLARACAO_DOMICILIO = 'DECLARACAO_DOMICILIO',
    DECLARACAO_AUTONOMO = 'DECLARACAO_AUTONOMO',
    DECLARACAO_QUESTIONARIO_JURIDICO = 'DECLARACAO_QUESTIONARIO_JURIDICO'
}
